import React, { useEffect, createElement } from 'react';
import { Play } from 'lucide-react';
const HOP_LINK = 'https://d0d38frttj2fs0yhx2url2skbi.hop.clickbank.net';
const ORANGE = '#E8651A';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
const handleCtaClick = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout');
  }
};
export function App() {
  useEffect(() => {
    // Inject Facebook Pixel Base Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '666521186552257');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=666521186552257&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (script.parentNode) document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen w-full bg-white text-gray-900" data-id="element-0">
      {/* TOP BAR */}
      <div className="w-full border-b border-gray-100" data-id="element-1">
        <div className="mx-auto max-w-[700px] px-5 sm:px-6 py-3 text-center" data-id="element-2">
          <p className="text-[11px] uppercase tracking-[0.22em] text-gray-500 font-medium" data-id="element-3">
            Health & Wellness Discovery
          </p>
        </div>
      </div>

      <article className="mx-auto max-w-[700px] px-5 sm:px-6 py-10 sm:py-14" data-id="element-4">
        {/* HEADLINE */}
        <h1 className="font-article text-center text-[28px] sm:text-4xl lg:text-[44px] font-bold leading-[1.2] text-gray-800 mb-5" data-id="element-5">
          They Labeled It "Normal Aging" Until This Simple Morning Habit Changed
          Everything...
        </h1>

        {/* AUTHOR LINE */}
        <p className="text-center text-sm text-gray-500 mb-10" data-id="element-6">
          By Martha R. <span className="text-gray-300 mx-1" data-id="element-7">|</span> Women's
          Wellness contributor
        </p>

        {/* BODY COPY */}
        <div className="mx-auto max-w-[680px] font-article text-[17px] sm:text-[18px] leading-[1.75] text-gray-800 space-y-5 mb-10" data-id="element-8">
          <p data-id="element-9">
            Hi, I'm Martha. For years, I just accepted that my stiff knees and
            aching hips were part of the "package deal" of turning 60. I stopped
            gardening, I stopped long walks, and I started planning my life
            around how many stairs I'd have to climb.
          </p>

          <p data-id="element-10">
            I tried everything you've probably tried too. But it wasn't until I
            stumbled across a short video explaining a tiny biological "glitch"
            that everything clicked. It wasn't about "wear and tear" like I was
            told.
          </p>

          <p data-id="element-11">
            It was about one simple thing I was missing in my morning routine. I
            was skeptical at first, but after seeing the science behind it, I
            decided to take a look. If you're tired of feeling like your body is
            older than your spirit, you need to see what this discovery is all
            about.
          </p>
        </div>

        {/* TEXT ABOVE VIDEO */}
        <p className="mx-auto max-w-[640px] text-center font-article text-[16px] sm:text-[17px] leading-relaxed text-gray-700 mb-5" data-id="element-12">
          I found the explanation in this short presentation. It's not a long
          watch, but it's eye-opening.
        </p>

        {/* VIDEO PLACEHOLDER */}
        <div className="mx-auto max-w-[640px] mb-4" data-id="element-13">
          <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="group relative block w-full aspect-video rounded-lg overflow-hidden bg-gray-900 shadow-md" aria-label="Watch the presentation" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/u2gN5ZJHJhcwkidStUCWA1/heylloyd-image-1779710607845.png" alt="Watch the presentation" className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-15" />
          </a>
        </div>

        {/* WARNING BELOW VIDEO */}
        <p className="mx-auto max-w-[600px] text-center text-xs sm:text-[13px] italic text-gray-500 leading-relaxed mb-10" data-id="element-16">
          ⚠️ Note: This video explains the exact method and why the traditional
          industry has kept it quiet. Watch it while the link is still active.
        </p>

        {/* CTA BUTTON */}
        <div className="mx-auto max-w-[520px] mb-3" data-id="element-17">
          <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="block w-full text-center py-5 px-6 rounded-full text-white font-bold text-lg sm:text-xl transition-all duration-200 hover:brightness-105 hover:shadow-xl shadow-lg" style={{
          backgroundColor: ORANGE
        }} data-id="element-18">
            Yes! Show Me The Solution →
          </a>
        </div>

        {/* DISCLAIMER UNDER BUTTON */}
        <p className="text-center text-[11px] sm:text-xs italic text-gray-500 leading-relaxed" data-id="element-19">
          Information is free. No credit card or registration required to watch
          the presentation.
        </p>
      </article>

      {/* FOOTER */}
      <footer className="border-t border-gray-100 mt-8" data-id="element-20">
        <div className="mx-auto max-w-[700px] px-5 sm:px-6 py-6 text-center" data-id="element-21">
          <p className="text-[11px] text-gray-400 leading-relaxed" data-id="element-22">
            © 2024 Health Discovery Blog{' '}
            <span className="mx-1.5 text-gray-300" data-id="element-23">|</span> Privacy Policy{' '}
            <span className="mx-1.5 text-gray-300" data-id="element-24">|</span> Disclaimer{' '}
            <span className="mx-1.5 text-gray-300" data-id="element-25">|</span> This page is for
            informational purposes only.
          </p>
        </div>
      </footer>
    </div>;
}